export default "/_next/static/chunks/bust-5-d.ae10e77426cf9374897f2348312b087c.glb";